import React, { useEffect, useState } from "react";
import './styles.css';
//internal and external componentscontainers
import { Typography, Paper, Box, Fade, Popper, Button, ThemeProvider, createTheme, ClickAwayListener, TextField, Checkbox } from '@mui/material';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import Textarea from '@mui/joy/Textarea';
import ProgressBar from "../../components/ProgressBar";
import SelectBoxPrimary from "../../components/SelectBoxPrimary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import DateSelector from "../../components/DateSelector";
import ActionsStandardTable from "../../components/ActionsStandardsTable";
import { getAction, updateAction } from "../../api/action";
import { getStaff } from "../../api/user";
import { useDispatch, useSelector } from "react-redux";
import StaffSelectBox from "../../components/SearchSelectBox/StaffSelectBox";
import { getClubDepartments, getProjectsByClub } from "../../api/club";
import SearchSelectBox from "../../components/SearchSelectBox";
import LicenceActionsStandardsTable from "../../components/LicenceActionsStandardsTable";
import { formatISO } from "date-fns";
import TasksTable from "../../components/TasksTable";
import { setSnackBarData } from "../../redux/reducers/common";
import { useTranslation } from "react-i18next";
import { hasObjectsUpdates, hasUpdates } from "../../common/logics";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: 0
                },
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: '13px !important',
                    padding: '10px !important',
                }
            }
        },
    }
})

const ActionDetailPopper = (props:any) => {
    const { isOpen, handleIsOpen, data, isReadOnly, module } = props;
    const [comment, setComment] = React.useState('');
    const [addEvalStandards, setAddEvalStandards] = React.useState(false);
    const [addLicenceStandards, setAddLicenceStandards] = React.useState(false);
    const currentClub = useSelector((state:any) => state.clubDetails);
    const saCriteria = useSelector((state:any) => state.evaluation.selectedSaCriteria);
    const [staffList, setStaffList] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [projects, setProjects] = useState([]);
    const [isFetchingAction, setIsFetchingAction] = useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const isJLActionRestrict = data?.isCreatedByJL && isAdmin;
    const isClubUserRestrict = data?.isCreatedByJL && !isAdmin;
    const dispatch = useDispatch();
    const [t] = useTranslation();

    // Ref to detect clicks inside the Paper — used as extra guard for ClickAwayListener
    const paperRef = React.useRef<HTMLDivElement>(null);

    const initialActionData = {
        id: null,
        name: '',
        description: '',
        standards: [],
        licenceStandards: [],
        tasks: [],
        startDate: null,
        endDate: null,
        status: 0,
        ownerName: null,
        ownerUserId: null,
        pastStatus: null,
        pastStatusDate: null,
        projectId: null,
        projectName: null,
        departmentId: null,
        departmentName: null,
    }
    const [actionData, setActionData]:any = useState(null);
    const [actionDataOG, setActionDataOG]:any = useState(null);

    const tableHead = [
        {
            key: 'standardName', displayName: 'standard',
        },
        {
            key: 'criteriaName', displayName: 'criteria',
        },
        {
            key: '', displayName: 'required for',
        },
        {
            key: '', displayName: ''
        }
    ]

    let initialTask: any = {checked: false, task: '', id: null};
    const manageTaskDelete = (index: number) => {
        let temp = actionData.tasks;
        temp = temp.filter((d:any, i:number) => i!==index);
        setActionData({...actionData, tasks: temp});
    }

    const fetchAction = async () => {
        setIsFetchingAction(true);
        const response = await getAction({id: data?.id || data.Id, pastStatusPeriod: 0});
        return response;
    }

    const fetchStaffs = async () => {
        const response = await getStaff({clubId: currentClub.id});
        return response;
    }

    const fetchDepartments = async () => {
        const response = await getClubDepartments({clubId: currentClub.id});
        return response;
    }

    const fetchProjects = async () => {
        const response = await getProjectsByClub({clubId: currentClub.id});
        return response;
    }

    // Fetch action data
    useEffect(() => {
        if (isOpen && data?.id) {
            setActionData(data);
            setActionDataOG(data);
            setIsFetchingAction(true);
            fetchAction().then((res: any) => {
                setActionData(res);
                setActionDataOG(res);
                setIsFetchingAction(false);
            });
        } else if (isOpen) {
            setActionData(data);
            setActionDataOG(data);
        } else {
            setActionData(initialActionData);
            setActionDataOG(initialActionData);
        }
    }, [isOpen, data?.id]);

    // Fetch other data
    useEffect(() => {
        if (isOpen && currentClub?.id) {
            Promise.all([
                fetchStaffs(),
                fetchDepartments(),
                fetchProjects()
            ]).then(([staffs, depts, projs]) => {
                setStaffList(staffs);
                setDepartments(depts);
                setProjects(projs);
            });
        }
    }, [isOpen, currentClub?.id]);

    const calcTaskPercentage = (taskData:any) => {
        if (taskData.length === 0) return 0;
      
        const completedCount = taskData.filter((task:any) => task.checked).length;
        const percentage = (completedCount / taskData.length) * 100;
      
        return percentage;
    }

    //handling tasks
    const handleChangeTask = (label:any, updatedValue:any, index:any) => {
        var tempTasks = actionData?.tasks ? actionData?.tasks : [];
        switch(label) {
            case 'addTask':
                tempTasks = [...tempTasks, updatedValue];
                break;
            case 'deleteTask': 
                const newTasks = tempTasks.filter((_:any, i:any) => i !== index);
                tempTasks = newTasks;
                break;
            default:
                tempTasks = tempTasks.map((item:any, i:any) => {
                    if (i == index) {
                        return { ...item, [label]: updatedValue };
                    } return item;
                });
                break;
        }
        const tempAction = {...actionData, tasks: tempTasks};
        setActionData(tempAction);
    };

    const manageClickAway = () => {
        if (true) {
            const tempActionData = actionData?.licenceStandards?.length > 0 ? {...actionData, licenceStandards: actionData?.licenceStandards?.map((d:any) => ({ standardId: d.licenceStandardId }))} : actionData;
            updateAction({actionId: actionData.id, action: tempActionData})
            .then(() => {
                const warningData:any = {isOpen: true, severity: 'success', message: t('ACTION_UPDATED_SUCCESSFULLY')};
                dispatch(setSnackBarData(warningData));
            });
        } handleIsOpen(actionData);
        setActionData(initialActionData);
    }

    // FIX: Guard against false "click away" triggers by checking if the click
    // actually originated inside our Paper element using the ref.
    const handleClickAway = (e: MouseEvent | TouchEvent) => {
        if (paperRef.current && paperRef.current.contains(e.target as Node)) {
            // Click was inside the paper — do nothing
            return;
        }
        if (hasObjectsUpdates(actionData, actionDataOG) && (!isAdmin || isJLActionRestrict)) {
            manageClickAway();
        }
        handleIsOpen();
    };

    return(
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Popper className='popperStyle' open={isOpen} transition disablePortal>
                    {({ TransitionProps }) => (
                        <Fade {...TransitionProps} timeout={350}>
                            <div>
                                <ClickAwayListener
                                    onClickAway={handleClickAway}
                                    mouseEvent="onMouseDown"
                                    touchEvent="onTouchStart"
                                >
                                    <Paper
                                        ref={paperRef}
                                        onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
                                        onClick={(e: React.MouseEvent) => e.stopPropagation()}
                                        sx={{ width: '1200px', height: '90vh', margin: 'auto', mt: '3vh' }}
                                    >
                                        <Box sx={{ p: 2, mt: 2, mb: 2, height: '80vh', overflowY: 'auto' }} onClick={(e: any) => e.stopPropagation()}>
                                            <Box className={'mb20'} onClick={(e: any) => e.stopPropagation()}>
                                                <Typography className="fw700 uppercase fs13 fs13">Action Details</Typography>
                                                <Box className={'adDetailsWrapper'} onClick={(e: any) => e.stopPropagation()}>
                                                    <Box className={'adDetails1'} onClick={(e: any) => e.stopPropagation()}>
                                                        <TextField fullWidth 
                                                        className={(isReadOnly || isClubUserRestrict) ? "cursorNotAllowed" : ""}
                                                        sx={{ // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                                '& .MuiInputBase-input.Mui-disabled': {
                                                                WebkitTextFillColor: 'black', // Makes the input text black
                                                                cursor: (isReadOnly || isClubUserRestrict) ? 'not-allowed' : 'text',
                                                                }}}
                                                        placeholder="Enter action Name" 
                                                        onChange={(e:any) => {setActionData({...actionData, name: e.target.value})}}
                                                        value={actionData?.name}
                                                        onClick={(e:any) => e.stopPropagation()}
                                                        disabled={isReadOnly || isClubUserRestrict} />
                                                        <JoyCssVarsProvider>
                                                            <Textarea 
                                                            sx={{ 
                                                                borderRadius: '6px',
                                                                mt: 1, 
                                                                fontSize: 13,
                                                             }}
                                                             slotProps={{
                                                                textarea: {
                                                                    sx: {
                                                                        cursor: (isReadOnly || isClubUserRestrict) ? 'not-allowed' : 'text'
                                                                    }
                                                                }
                                                             }}
                                                             className={(isReadOnly || isClubUserRestrict) ? "cursorNotAllowed" : ""}
                                                             onChange={(e:any) => {setActionData({...actionData, description: e.target.value})}}
                                                             placeholder='Action description' 
                                                             minRows={2} maxRows={8} 
                                                             value={actionData?.description}
                                                             readOnly={isReadOnly || isClubUserRestrict} />
                                                        </JoyCssVarsProvider>
                                                    </Box>
                                                    <Box className={'adDetails2'} onClick={(e: any) => e.stopPropagation()}>
                                                        <StaffSelectBox 
                                                        options={staffList}
                                                        selectedValue={actionData?.ownerUserId}
                                                        manageSelect={(e:any) => {setActionData({...actionData, ownerName: e.displayName, ownerUserId: e.id})}}
                                                        label={'Owner Name'}
                                                        disabled={isReadOnly || isJLActionRestrict}
                                                        />
                                                        <SearchSelectBox 
                                                        options={departments}
                                                        selectedValue={actionData?.departmentId}
                                                        manageSelect={(e:any) => {setActionData({...actionData, departmentName: e.name, departmentId: e.id})}}
                                                        label={'Department'}
                                                        key={'name'}
                                                        disabled={isReadOnly || isJLActionRestrict}
                                                        />
                                                        <StaffSelectBox 
                                                        options={projects}
                                                        selectedValue={actionData?.projectId}
                                                        manageSelect={(e:any) => {setActionData({...actionData, projectName: e.displayName, projectId: e.id})}}
                                                        label={'Project Name'}
                                                        key={'displayName'}
                                                        disabled={isReadOnly || isJLActionRestrict}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box className={'adTaksContainer mb20'} onClick={(e: any) => e.stopPropagation()}>
                                                <Typography className="fw700 uppercase fs13">Tasks</Typography>
                                                <Box className={'adTaskToDos'} onClick={(e: any) => e.stopPropagation()}>
                                                    <TasksTable data={actionData?.tasks ? actionData?.tasks : []} 
                                                    isLoading={isFetchingAction}
                                                    handleChange={handleChangeTask}
                                                    isReadOnly={isReadOnly || isJLActionRestrict} />
                                                </Box>
                                            </Box>
                                            <Box className={'mb20'} onClick={(e: any) => e.stopPropagation()}>
                                                <Typography className="fw700 uppercase fs13">Status</Typography>
                                                <Box className={'adStatusContainer'} onClick={(e: any) => e.stopPropagation()}>
                                                    <Box className={'adStatusCommentWrapper'} onClick={(e: any) => e.stopPropagation()}>
                                                        <JoyCssVarsProvider>
                                                            <Textarea 
                                                            sx={{ borderRadius: '6px', mt: 1, fontSize: 13 }} 
                                                            slotProps={{
                                                            textarea: {
                                                                sx: {
                                                                    cursor: (isReadOnly || isJLActionRestrict) ? 'not-allowed' : 'text'
                                                                }
                                                            }
                                                            }}
                                                            onChange={(e:any) => {setActionData({...actionData, statusComment: e.target.value})}} 
                                                            placeholder='Status comment' 
                                                            minRows={8}
                                                            readOnly={isReadOnly || isJLActionRestrict}
                                                            value={actionData?.statusComment}/>
                                                        </JoyCssVarsProvider>
                                                    </Box>
                                                    <Box className={'adStatusDate'} onClick={(e: any) => e.stopPropagation()}>
                                                        <Box className={'statusBoxContainer'} onClick={(e: any) => e.stopPropagation()}>
                                                            <SelectBoxPrimary 
                                                            options={[0, 1, 2, 3, 4]} 
                                                            isStatus={true} 
                                                            selected={actionData?.status} 
                                                            manageChange={(d:any) => {setActionData({...actionData, status: d})}}
                                                            report={'rabg'}
                                                            disabled={isReadOnly || isJLActionRestrict}/>
                                                        </Box>
                                                        <DateSelector 
                                                        manageChange={(e:any) => {setActionData({...actionData, startDate: e ? formatISO(new Date(e)) : null})}}
                                                        dateValue={actionData?.startDate}
                                                        label={'Start Date'}
                                                        disabled={isReadOnly || isJLActionRestrict} />
                                                        <DateSelector 
                                                        manageChange={(e:any) => {setActionData({...actionData, dueDate: e ? formatISO(new Date(e)) : null})}}
                                                        dateValue={actionData?.dueDate}
                                                        label={'Due Date'}
                                                        disabled={isReadOnly}/>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box className={'mt10 mb20'} onClick={(e: any) => e.stopPropagation()}>
                                                <Typography className="fw700 uppercase fs13">Evaluation Standards</Typography>
                                                {
                                                    (!isAdmin || isJLActionRestrict) &&
                                                    <Button className='smallButton' sx={{ float: 'right', zIndex: 9 }} disableElevation onClick={() => {setAddEvalStandards(true)}} variant='contained' size='small' startIcon={<FontAwesomeIcon icon={faPlus} />} disabled={addEvalStandards}>
                                                        {'Add Standards'}
                                                    </Button>
                                                }
                                                <ActionsStandardTable 
                                                head={tableHead} 
                                                data={actionData?.standards} 
                                                addStandards={addEvalStandards} 
                                                handleClick={() => setAddEvalStandards(false)}
                                                manageDone={(d:any) => {setActionData({...actionData, standards: [...actionData?.standards, d]}); setAddEvalStandards(false);}}
                                                />
                                            </Box>
                                            <Box className={'mt10 mb20'} onClick={(e: any) => e.stopPropagation()}>
                                                <Typography className="fw700 uppercase fs13">Licence Standards</Typography>
                                                {
                                                    (!isAdmin || isJLActionRestrict) &&
                                                    <Button className='smallButton' sx={{ float: 'right', zIndex: 9 }} disableElevation onClick={() => setAddLicenceStandards(true)} variant='contained' size='small' startIcon={<FontAwesomeIcon icon={faPlus} />} disabled={addLicenceStandards}>
                                                        {'Add Standards'}
                                                    </Button>
                                                }
                                                <LicenceActionsStandardsTable 
                                                head={tableHead} 
                                                data={actionData?.licenceStandards} 
                                                addStandards={addLicenceStandards} 
                                                handleClick={() => setAddLicenceStandards(false)}
                                                manageDone={(d:any) => {setActionData({...actionData, licenceStandards: [...actionData?.licenceStandards, d]}); setAddLicenceStandards(false);}}
                                                />
                                            </Box>
                                        </Box>
                                        {/* disabled the save and cancdel button to maintain the standard */}
                                        {
                                            (!isAdmin || isJLActionRestrict) && false &&
                                            <Box className={'adButtonsWrapper'} onClick={(e: any) => e.stopPropagation()}>
                                                <Button className='smallButton'
                                                    disableElevation 
                                                    onClick={() => handleIsOpen()} 
                                                    variant='contained' 
                                                    size='small'>
                                                    {'cancel'}
                                                </Button>
                                                <Button className='smallButton'
                                                    disableElevation 
                                                    onClick={() => manageClickAway()} 
                                                    variant='contained' 
                                                    size='small'>
                                                    {'Save'}
                                                </Button>
                                            </Box>
                                        }
                                    </Paper>
                                </ClickAwayListener>
                            </div>
                        </Fade>
                    )}
                </Popper>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default ActionDetailPopper;